import "@accessible360/accessible-slick";

export const PXSlider = (function () {
    "use strict";

    let $sliders;

    function init() {
        $sliders = $(".pxblock--slider .slides");

        $sliders.each(function () {
            if ($(this).hasClass("products")) {
                initProductSlider($(this));
            } else if ($(this).hasClass("videos")) {
                initVideoSlider($(this));
            }
        });
    }

    function initProductSlider($slider) {
        $slider.slick({
            arrowsPlacement: "afterSlides",
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    function initVideoSlider($slider) {
        $slider.slick({
            arrowsPlacement: "afterSlides",
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    return {
        init: init,
    };
})();
